import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { updateUriRef } from '../../actions/filterActions';
import { trackSortEvent } from '../../utils/tracking/searchBrowse/trackSortEvent';
import { createNewFilterUriRef } from '../../utils/uriUtils';
import { SORT } from '../SbSharedRefineMenu/sbSharedRefineMenuConstants';

// styles
import styles from './SbRespSortItems.scss';

function SbRespSortItemsComponent(props) {
    const { itemSearch, onChange, generatedUriRef } = props;
    const selectedValue = get(itemSearch, 'sort.currentOption.urlLabel');
    const options = itemSearch.sort.options.map(sortOption => {
        return {
            value: sortOption.urlLabel,
            label: sortOption.displayName,
        };
    });

    return (
        <div className={styles.container}>
            <BasicSelect
                size="medium"
                value={selectedValue}
                dataTn="sb-resp-sort-by"
                options={options}
                onChange={e => {
                    onChange(e.target.value, generatedUriRef);
                }}
            />
        </div>
    );
}

SbRespSortItemsComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    generatedUriRef: PropTypes.string,
};

const mapStateToProps = ({ filters }) => ({
    generatedUriRef: filters.generatedUriRef,
});

function mapDispatchToProps(dispatch) {
    return {
        onChange(value, generatedUriRef) {
            const filterName = SORT;
            const filterValue = {
                urlLabel: value,
            };
            const uriRef = createNewFilterUriRef(generatedUriRef, filterName, value);
            dispatch(updateUriRef({ filterName, filterValue, uriRef }));
            trackSortEvent(value);
        },
    };
}

export const SbRespSortItems = createFragmentContainer(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SbRespSortItemsComponent),
    {
        itemSearch: graphql`
            fragment SbRespSortItems_itemSearch on ItemSearchQueryConnection {
                sort {
                    options {
                        urlLabel
                        displayName
                    }
                    currentOption {
                        urlLabel
                    }
                }
            }
        `,
    }
);
